<template>
<div class="item-wrap user-tab-wrap pos-r">
    <scroller
        ref="infinite"
        class="scroller"
        :on-refresh="_onRefresh"
        :on-infinite="_onEndReached"
        :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
    >
        <div class="list-wrap user-list-wrap">
            <div class="user-list-item-wrap" v-for="(item, index) in dataSources" :key="index">
                <home-inheritor-item v-if="user_type == Constants.USER_MASTER" :user_type="user_type" :item="item" :sort="index + 1" />
                <home-lecturer-item v-if="user_type == Constants.USER_TEACHER" :user_type="user_type" :item="item" :sort="index + 1" />
            </div>
            <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
        </div>
    </scroller>
</div>
</template>

<script>
import HomeLecturerItem from '@/components/item/homeLecturerItem'
import HomeInheritorItem from '@/components/item/homeInheritorItem'
export default {
    components: {
        HomeLecturerItem,
        HomeInheritorItem,
    },
    data() {
        return {
            loading: true,
            dataSources: [],
            user_type: this.$route.query.user_type || this.Constants.USER_MASTER,
            page: 1,
            limit: 10,
        };
    },
    mounted() {
        this._requestDataSources();
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        async _requestDataSources() {
            let {
                user_type,
                dataSources
            } = this;
            let url = this.API.master_user_list;
            let data = {
                user_type,
                page: this.page,
                limit: this.limit,
            };
            try {
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.dataSources.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.dataSources = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },
    },
};
</script>

<style lang="less" scoped>
.user-tab-wrap {
    height: calc(100vh);
    .user-list-item-wrap {
        margin: 0 1.5rem;
    }
}
</style>
